import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RadioGroup, FormControlLabel, Radio, Box } from "@mui/material";

import { ActionButton, FormDialog, InputField } from "../v3";
import { ProjectService } from "../../services";

export const UpdateStatus = ({ open, onClose = () => {}, currentStatus, currentEndDate, onSuccess = () => {} }) => {
  const [status, setStatus] = useState(currentStatus || "TODO");
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    setStatus(currentStatus || "TODO");
    setEndDate(currentEndDate || null);
  }, [currentStatus, currentEndDate]);

  const handleCloseModal = () => {
    onClose();
  };

  const handleUpdateStatus = async () => {
    setLoading(true);
    try {
      const payload = { status };

      if (status === "DONE") {
        if (endDate && endDate.trim() !== "") payload.endDate = endDate;
      } else {
        payload.endDate = null;
      }

      await ProjectService.updateProject(id, payload);
      toast.success("Project status updated successfully");
      onSuccess?.();
    } catch (error) {
      toast.error("Failed to update project status");
      console.error("🚀 ~ onSubmit ~ error:", error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const statusOptions = [
    { value: "TODO", label: "To Do" },
    { value: "INPROGRESS", label: "In Progress" },
    { value: "DONE", label: "Completed" },
  ];

  return (
    <>
      <FormDialog
        open={open}
        title="Update Status"
        actions={
          <>
            <ActionButton buttonText="Cancel" onButtonClick={handleCloseModal} variant="outlined" />
            <ActionButton buttonText="Save" onButtonClick={handleUpdateStatus} loading={loading} />
          </>
        }
      >
        <Box sx={{ mt: 1, width: 300 }}>
          <RadioGroup
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {statusOptions.map((item) => (
              <FormControlLabel
                key={item.value}
                value={item.value}
                label={item.label}
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "#674BF5",
                      },
                    }}
                  />
                }
              />
            ))}
          </RadioGroup>
          {status === "DONE" && (
            <Box sx={{ mt: 2 }}>
              <InputField
                required
                type="date"
                label="Completion Date"
                name="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Box>
          )}
        </Box>
      </FormDialog>
    </>
  );
};
